Namespace 'Monitoring.Reports.Executive'

class Monitoring.Reports.Executive.WordsCloudView extends Backbone.View

  className: 'words-cloud'
  template: JST['backbone/templates/monitoring/reports/executive/words_cloud']

  initialize: (@options = {}) ->
    # just set @options

  render: ->
    @$el.html(@template(name: @options.name))
    @$el.addClass('processing')

    params = {
      account_id: @options.account_id
      date_from_ISO: @options.date_from_ISO
      date_to_ISO: @options.date_to_ISO
      exclude_page_owner_generated: true
      ngrams_limit: 20
    }
    params = _.extend(params, {ancestors: @options.ancestors}) if @options.ancestors

    job = new Monitoring.Methods.AsyncJob()
    job.bind('completed', @_renderCloud)
    job.start('words', params)

  _renderCloud: (data) =>
    @$el.removeClass('processing')

    renderer = new Monitoring.Methods.RenderWordCloud(data.topic_ranking)
    renderer.renderInElement(@el.querySelector('canvas'))

    @trigger('rendered')
